import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  baseUrl = environment.BASE_URL;
  kycUpdated: boolean = false;
  regionDataSources = [
    `${this.baseUrl}common-service/region-wise`,
    `${this.baseUrl}common-service/company-size`,
    `${this.baseUrl}common-service/turnover`,
    `${this.baseUrl}common-service/category-management`,
  ];
  graphDataSources = [
    `${this.baseUrl}rfq/customer/status-count`,
    `${this.baseUrl}customer/user-profile/customerProfileDashboard`,
    `${this.baseUrl}oms/order-customer/dashboardStatusCount`,
    `${this.baseUrl}rfq/customer/CustomerQuoteStatusCount`,
  ];
  constructor(private http: HttpClient) {}

  public requestDataForRegions(): Observable<any[]> {
    let response1 = this.http.get(this.regionDataSources[0]);
    let response2 = this.http.get(this.regionDataSources[1]);
    let response3 = this.http.get(this.regionDataSources[2]);
    let response4 = this.http.get(this.regionDataSources[3]);
    // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
    return forkJoin([response1, response2, response3, response4]);
  }

  public requestDataForGraphs(
    param1: any,
    param2: any,
    customerRefId: any,
    customerUserId: any,
  ): Observable<any[]> {
    let params = new HttpParams().set('userId', customerUserId);
    const body = {
      startDate: this.formatDateToDDMMYYYY(param1),
      endDate: this.formatDateToDDMMYYYY(param2),
      customerRefId: parseInt(customerRefId),
    };

    const body2 = {
      startDate: this.formatDateToDDMMYYYY(param1),
      endDate: this.formatDateToDDMMYYYY(param2),
      customerId: parseInt(customerRefId),
    };

    let response1 = this.http.post(this.graphDataSources[0], body);
    let response2 = this.http.get(this.graphDataSources[1], { params });
    let response3 = this.http.post(this.graphDataSources[2], body2);
    let response4 = this.http.post(this.graphDataSources[3], body);

    return forkJoin([response1, response2, response3, response4]);
  }

  public formatDateToDDMMYYYY(dateString: any) {
    if (dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    } else return null;
  }
}
